export default "__VITE_PUBLIC_ASSET__3a99c499__"